/* Pixel Magnético · Plantilla B · galería, oferta 1/2 sets y disparo COD (Releasit) */
(function(){
if(window.PB)return;
var PB=window.PB={};
var SEL=['#rsi_buy_now_button','.rsi_buy_now_button','._rsi-buy-now-button','._rsi-buy-now-button-app-block-hook button','._rsi-buy-now-button-app-block-hook a','.rsi-btn-skel'];
function $$(q,r){return Array.prototype.slice.call((r||document).querySelectorAll(q))}

function gallery(root){
  if(root.getAttribute('data-pb-ready'))return;root.setAttribute('data-pb-ready','1');
  var slides=$$('[data-pb-slide]',root),thumbs=$$('[data-pb-thumb]',root);
  if(!slides.length)return;
  function show(k){
    slides.forEach(function(s,n){s.classList.toggle('pb-on',n===k)});
    thumbs.forEach(function(b,n){b.setAttribute('aria-pressed',String(n===k))});
  }
  thumbs.forEach(function(b,n){b.addEventListener('click',function(){show(n)})});
  show(0);
}

/* oferta: variante y cantidad real en TODOS los formularios (precio por unidad x quantity) */
function setOffer(input){
  $$('[data-pb-offer]').forEach(function(l){l.classList.toggle('pb-on',l.querySelector('input')===input)});
  var v=input.getAttribute('data-variant'),q=input.getAttribute('data-buyqty')||'1';
  $$('form[action$="/cart/add"] input[name="id"]').forEach(function(i){i.value=v});
  $$('input[name="product-id"]').forEach(function(i){i.value=v});
  $$('input[name="quantity"]').forEach(function(i){i.value=q;i.setAttribute('value',q)});
  $$('[data-pb-was]').forEach(function(n){n.textContent=input.getAttribute('data-was')});
  $$('[data-pb-now]').forEach(function(n){n.textContent=input.getAttribute('data-now')});
}

/* COD Releasit: primero click al boton, nunca _rsiV2.setState como primer camino */
function findReleasitButton(){for(var i=0;i<SEL.length;i++){var n=document.querySelector(SEL[i]);if(n)return n}return null}
PB.findReleasitButton=findReleasitButton;
PB.open=function(){
  var on=document.querySelector('[data-pb-offer] input:checked');
  if(on)setOffer(on);
  setTimeout(function(){
    var r=findReleasitButton();
    if(r){r.click();return}
    var n=0,poll=setInterval(function(){
      n++;var x=findReleasitButton();
      if(x){clearInterval(poll);x.click();return}
      if(n>30){clearInterval(poll);if(window._rsiV2&&typeof window._rsiV2.setState==='function'){try{window._rsiV2.setState({isOpen:true})}catch(e){}}}
    },100);
  },50);
};

document.addEventListener('change',function(e){
  var i=e.target&&e.target.closest&&e.target.closest('[data-pb-offer] input');
  if(i)setOffer(i);
});
document.addEventListener('click',function(e){
  var t=e.target&&e.target.closest&&e.target.closest('[data-pb-cta]');
  if(t){e.preventDefault();PB.open()}
});

function init(){
  $$('[data-pb-gallery]').forEach(gallery);
  var on=document.querySelector('[data-pb-offer] input:checked');
  if(on)setOffer(on);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
